import { ThemeProvider } from '@emotion/react'
import {
  ThemeProvider as DSThemeProvider,
  createTheme,
} from '@fairfashion/design-system'

import { ConfirmModalProvider } from '../components/ConfirmModal'
import { FeedbackAlertProvider } from '../components/FeedbackAlert'
import theme from '../styles/theme'

import { AuthProvider } from './auth'
import { GlobalDataProvider } from './globalData'

const dsTheme = createTheme({})

interface ContextProvidersProps {
  children: React.ReactNode
}

export const ContextsProviders = ({ children }: ContextProvidersProps) => {
  return (
    <AuthProvider>
      <GlobalDataProvider>
        <ThemeProvider theme={theme}>
          <DSThemeProvider theme={dsTheme}>
            <ConfirmModalProvider>
              <FeedbackAlertProvider>{children}</FeedbackAlertProvider>
            </ConfirmModalProvider>
          </DSThemeProvider>
        </ThemeProvider>
      </GlobalDataProvider>
    </AuthProvider>
  )
}
